export const appId = 'org.openedx.frontend.app.static.pages';
export const templateRole = 'org.openedx.frontend.role.template';
export const faqRole = 'org.openedx.frontend.role.faq';
export const ansRole = 'org.openedx.frontend.role.ans';
export const slaRole = 'org.openedx.frontend.role.sla';
export const dashboardRole = 'org.openedx.frontend.role.dashboard';
